export const getModal = (state: Partial<GlobalState>): ModalsState =>
  state.modals || ({} as ModalsState);
